import {
    Button,
    Container,
    Grid,
    Paper,
    TextField,
    Typography,
    Box,
    ThemeProvider,
    Stack,
    Chip,
   
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import RatingLabel from "../Components/RatingLabel";
  import { useForm } from "react-hook-form";
  import { useNavigate, useSearchParams } from "react-router-dom";
  import { addResponseAssessmentByStId, getAllStaff, getAssessmentByStId, getInternshipRequestById, updateStudentSupervisor,
    getAssessmentReportByStId, addResponseAssessmentReportByStId, getAssessmentPresentCoopByStId,
    addResponseAssessmentPresentCoopByStId
   } from "../api/crud";
  import { useDispatch } from "react-redux";
  import { updateSnackbar } from "../redux/action/dataAction";
  import { createTheme} from '@mui/material/styles';
  import { matchOptions } from "../utils/function";
  import { optionsBranch } from "../data/branch-data";
  import { useSelector } from "react-redux";
  
  import '@fontsource/prompt';
  import { CircularProgress } from "@mui/material";
  import useMediaQuery from "@mui/material/useMediaQuery";
  import { is } from "date-fns/locale";
  
  
  
  
  const theme = createTheme({
    typography: {
      fontFamily: 'Prompt, sans-serif',
      fontWeightBold: 600,
      fontWeightLight: 300,
    },
  });
  
  const AssessmentPresentCoop = () => {
    const isMobile = useMediaQuery('(max-width:767px)');
    const dispatch = useDispatch();
    const hookForm = useForm();
    const navigate = useNavigate();
    const { handleSubmit, register, reset,setValue } = hookForm;
    const [searchParams] = useSearchParams();
    const req_id = searchParams.get("req_id");
  
    const [studentData, setStudentData] = useState({});
    const [studentId, setStudentId] = useState("");
    const [studentName, setStudentName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [companyID, setCompanyID] = useState("");
    const [b_id, set_b_id] = useState("");
    const [viewonly, setViewonly] = useState(false);
    const [supervisor, setSupervisor] = useState("");
    const [score, setScore] = useState(0);
  
  
    const profile = useSelector((state) => state.profileReducer.profile);
  
    useEffect(() => {
      if (
        !profile ||
        (profile.m_role !== "staff" && profile.id !== req_id?.slice(0, 8))
      ) {
        navigate("/");
      }else if(profile.m_role !== "staff" && profile.id === req_id?.slice(0, 8)){
        setViewonly(true);
            //getAssessmentByStId(req_id);
      }
  
    }, [profile]);
  
  
      const lists = [
          { label: "ความครบถ้วนของเนื้อหา" },
          { label: "การแก้ปัญหาตรงกับวัตถุประสงค์" },
          { label: "ความชัดเจนในการเสนอแนะแนวทางแก้ไข" },
          { label: "ความชัดเจนในการตอบคำถาม " },
          { label: "การนำเสนอ " },

      ];

      const lists2 = [
          { label: "ความเหมาะสมของเนื้อหาและการใช้สื่อ" },
          { label: "ลำดับขั้นตอนการนำเสนอ " },
          { label: "การใช้เวลาในการนำเสนอ" },
          { label: "ความครบถ้วนของเนื้อหา" },
          { label: "การแต่งกาย บุคลิกภาพ" },

      ];
  
    
  
  
    const getDataById = () => {
  
    getAssessmentPresentCoopByStId(req_id)
        .then((res) => {
         // console.log(res);       
          setStudentData(res);
          res && setViewonly(true);
          const score = parseInt(res?.list_1) + parseInt(res?.list_2) + parseInt(res?.list_3) + parseInt(res?.list_4) + parseInt(res?.list_5) 
          + parseInt(res?.list_6) + parseInt(res?.list_7) + parseInt(res?.list_8)+ parseInt(res?.list_9) + parseInt(res?.list_10);
          setScore(score);
          //console.log("res", res);
  
          reset(res);
        })
        .catch((err) => {
          console.log(err);
        });
        
        getInternshipRequestById(req_id)
        .then((resArr) => {
          const res = resArr[0];
          // console.log("dataStudent", res);
  
          if (res) {
            setStudentId(res.st_id);
            setStudentName(res.st_name);
            set_b_id(res.b_id);
            setCompanyName(res.cp_name);
            setCompanyID(res.cp_id);
            supervisorNameOptions(res?.supervisor)
            studentData?.evaluatorName == null
            && setValue("evaluatorName", supervisor);
  
            setValue("company.name_th", res.cp_name);
          }
        })
        .catch((err) => {
          console.log(err);
        });
  
  
    };
  
    useEffect(() => {
      if (req_id) {
        getDataById();
       
      } else {
        navigate("/");
      }
    }, [req_id, supervisor, setViewonly]);
  
    const supervisorNameOptions = async (value) => {
      const response = await getAllStaff();
      console.log("supervisor", response);
      setSupervisor(response.find((item) => item.id === value).name);
      
    };
  
  
    const onSubmit = async (formValue) => {
      try {
        const response = await addResponseAssessmentPresentCoopByStId(req_id, formValue, studentData == null ? 0 : 1);
  
        //console.log("assessment", response);
  
        dispatch(
          updateSnackbar({
            open: true,
            content: "บันทึกการประเมินเรียบร้อยแล้ว",
          })
        );
      } catch (error) {
        console.warn(error);
  
        dispatch(
          updateSnackbar({
            open: true,
            content: "มีข้อผิดพลาด",
          })
        );
      }
    };
  
    return (
      <ThemeProvider theme={theme}>
      {!studentId ? ( 
        // ถ้าเป็น moblie ไม่ต้องใช้ Container และ Box แล้ว
  
                <Container>


                    <Box
                        flexDirection={"column"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        padding={4}
                        sx={{ width: "100%" }}
                    >
                        <CircularProgress />
                        Loading...

                    </Box>
                </Container>) 
      
      : (
  
      <Container maxWidth="md">
        <Paper elevation={isMobile ? 0 : 5} sx={{
         p: isMobile ? 1 : 5, mt:3
        }}>
   
          <Box mb={3} textAlign="Start">
                  <Grid sm={2} md={2}
                  >
                    <Typography variant="h4" color="primary" sx={{ fontWeight: 'bold', color: '#86191f' }}>
                      <img src={'./assets/images/logo_no_bg.png'} alt="BUU|ENG" width="25%" />
                    </Typography>
                  </Grid>
           <Grid sm={4} md = {10}>
  
            <Stack  alignItems="Start" justifyContent="Left"
             >
            <Typography variant={isMobile ? "h6" : "h4"} color="primary" sx ={{fontWeight: 'bold'
            }}>
             แบบประเมินการนำเสนอผลการปฏิบัติงานสหกิจศึกษา
            </Typography>
          
            <Typography variant={isMobile ? "subtitle1" : "h6"} color="textSecondary" sx={
              { fontWeight: 'bold'}
            }>
             คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา
            </Typography>
            </Stack>
            </Grid>
          </Box>
          
          
            
                
              <Box mb={2} textAlign="Start" bgcolor="#f5f5f5" borderRadius={2} p={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} >
              <Chip color="primary" label={`RequestID: ${req_id || ''}`} />
              </Grid>
              {/* <Grid item xs={12} md={8} textAlign={"start"}>
              
                    <Typography sx={{ fontSize: 16, fontWeight:
                    'bold', fontSize: '1.2em'
                    }}>ขัอมูลนิสิตฝึกงาน </Typography>
                  </Grid> */}
              <Grid item xs={12} md={3} textAlign={
                "center"
              }>
                {studentId !== null  ? (
                  <img
                    src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${studentId}`}
                    width="120px"
                  />
                ) : (
                  <img src={`./assets/images/user.png`} width="120px" />
                )}
                 
              </Grid>
             
                <Grid item xs={12} md={9}>
                  
                  <Grid item xs={6} >
                    <Typography>{"ข้อมูลนิสิต"}</Typography>
                  </Grid>
                  <Grid item xs={4} >
                    <Typography sx={{ fontSize: 16, fontWeight: 'bold', fontSize: '1.2em'}}>{studentId}</Typography>
                  </Grid>
  
                  <Grid item xs={12} md={6}>
                    <Typography sx={{ fontSize: 16, fontWeight: 'bold', fontSize: '1.2em'}}>{studentName} </Typography>
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <Typography sx={{ fontSize: 16, fontWeight: 'bold', fontSize: '1.2em'}}>{matchOptions(optionsBranch, b_id)}</Typography>
                  </Grid>
                    
                  <Grid item xs={12} md={8}>
                    <Typography sx={{ fontSize: 16 }}>สถานประกอบการที่ฝึกงาน: </Typography>
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <Typography sx={{ fontSize: 16, fontWeight: 'bold', fontSize: '1.2em'}}>{companyName}</Typography>
                  </Grid>
                  
         
  
                    {/* <Grid item xs={12}>
                      <TextField
                        label="ฝ่าย/แผนกที่ฝึกงาน"
                        {...register("department")}
                      />
                    </Grid> */}
                  <Grid item xs={4}>
                  <Typography >อาจารย์นิเทศ:</Typography>
                  </Grid>
                  <Grid item xs={12}>
                  <Typography sx={{ fontSize: 16, fontWeight: 'bold', fontSize: '1.2em'}}>{supervisor}</Typography>
                  </Grid>
              
                  </Grid>
  
                  
                  <Grid item xs={12}>
                    <Box p={1} border={1} bgcolor="#faebd7" borderColor="grey.300" borderRadius={2} textAlign="center" alignItems={"center"}>
                      <Typography sx={{ fontWeight: "bold" }}>คะแนนรวม: (เต็ม 50)</Typography>
                      
                      {studentData == null ? (
                        <Typography>ยังไม่มีการประเมิน</Typography>
  
                      ) : (
                              <div>
                                 
                                <Typography>ผลการประเมิน {score} คะแนน</Typography>
                                {profile.m_role === "staff" && (
                                <Button variant="contained" color="primary" onClick={() => {
                                        viewonly ? setViewonly(false) : setViewonly(true);
                                      } }>
                                        {viewonly ? 'แก้ไขคะแนน' : 'ยกเลิก'}
                                      </Button>
                                )}
                              </div>
                            )}  
                          </Box>
                        </Grid>
              
  
                  </Grid>
                  </Box>
  
           
         
  
          <form onSubmit={handleSubmit(onSubmit)}>
  
            <Box mb={3} p={2} border={1} bgcolor= "#e6e6fa"  borderColor="grey.300" borderRadius={2}>
              <Typography variant="h5" color="primary" fontWeight={'bold'} >
                ส่วนที่ 1 
              </Typography>
              {!isMobile ?(
              <Typography variant="h6" color="black" marginBottom={2}>
                ประเมินผลการนำเสนอผลการปฏิบัติงานสหกิจศึกษา
              </Typography>):(
                <Typography variant="h6" color="black" marginBottom={2}>
                หัวข้อการประเมิน
              </Typography>
  
              )}
  
              <Grid container spacing={1} >
                <Container>
                <Typography variant="subtitle1" color="black" marginBottom={2}>
                ส่วนที่ 1.1  ด้านวิชาการ 
                </Typography>
  
                {lists.map((list, index) => (
                  <Grid item xs={12} key={index}>
                    <Box p={2} border={1} bgcolor="white" borderColor="grey.300" borderRadius={2} display="flex" flexDirection="column" alignItems= "top"
                    >
                     
                      <RatingLabel id={index + 1} label = {list.label} hookForm={hookForm} viewonly={viewonly} />
                     
                    </Box>
                    
                  </Grid>
                ))}
                </Container>
  
                <Container>
                <Typography variant="subtitle1" color="black" marginBottom={2}>
                ส่วนที่ 1.2  การนำเสนอ
                </Typography>
  
                {lists2.map((list, index) => (
                  <Grid item xs={12} key={index}>
                    <Box p={2} border={1} bgcolor="white" borderColor="grey.300" borderRadius={2} display="flex" flexDirection="column" alignItems= "top"
                    >
                     
                      <RatingLabel id={index + 6} label = {list.label} hookForm={hookForm} viewonly={viewonly} />
                     
                    </Box>
                    
                  </Grid>
                ))}
                </Container>
              </Grid>
            </Box>
  
  
  
            <Box mb={3} p={2} border={1} bgcolor= "#e6e6fa"  borderColor="grey.300" borderRadius={2}>
              <Typography variant="h6" color="primary" gutterBottom>
                ส่วนที่ 2 ข้อเสนอแนะอื่น ๆ 
              </Typography>
              <Grid container spacing={3} >
                <Grid item xs={12}>
                  <Box border={1} bgcolor="white" borderColor="grey.300" borderRadius={2}>
                  <TextField
                    multiline
                    minRows={5}
                    label="ข้อเสนอแนะ"
                    disabled={viewonly}
                    fullWidth
                    {...register("comment")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                  />
                  </Box>
                </Grid>
              </Grid>
            </Box>
  
            <Box mb={3} p={2} border={1} bgcolor= "#e6e6fa" borderColor="grey.300" borderRadius={2}>
              <Typography variant="h6" color="primary" gutterBottom>
                ผู้ประเมิน / อาจารย์นิเทศ
              </Typography>
              <Grid container spacing={3} >
                <Grid item xs={12} md={6}>
                  <Box  bgcolor="white" borderColor="grey.300" borderRadius={2}>
                  <TextField
                    label="ชื่อผู้ประเมิน"
                    fullWidth
                    
                    {...register("evaluatorName")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    disabled={viewonly}
                    
                  />
                  </Box>
                </Grid>
  
                <Grid item xs={12} md={6}>
                  <Box  bgcolor="white" borderColor="grey.300" borderRadius={2}>
                  <TextField
                    label="วัน/เวลาที่ประเมิน"
                    fullWidth
                    {...register("timestamp")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    disabled
                  />
                  </Box>
                </Grid>
              </Grid>
            </Box>
  
            <Grid item xs={12} textAlign="center">
              {profile.m_role === "staff" && (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                disabled ={viewonly}
              >
                ส่งผลประเมิน
              </Button>
              )}
            </Grid>
          </form>
        </Paper>
      </Container>)}
      </ThemeProvider>
    );
  };
  
  export default AssessmentPresentCoop;
  